let DEBUG = true;
let globalIframeRef;
function DRMSource(options) {
    let player = this;
    player.eme();
    const isSafari = videojs.browser.IS_SAFARI;
    if (isSafari) {
        player.ready(() => {
            player.eme.initLegacyFairplay();
        });
    }
    DEBUG && console.log('VideoJS options', player.options());
    DEBUG && console.log('DRMSource plugin', options);
    let builtSources = buildSourcesFromVPP(options);
    let selected = player.selectSource(builtSources);
    DEBUG && console.log('selected source', selected);
    if (!selected) {
        console.warn('No video type can be selected by VideoJS');
    }
    player.src(selected.source || builtSources);
    return;
    function buildSourcesFromVPP(options) {
        const vppData = options.src;
        const src = vppData.source.src;
        const vppKeySystems = vppData.keySystems;
        const videoType = 'application/x-mpegURL';
        let sources = [
            {
                src,
                type: videoType,
                withCredentials: false,
                keySystems: {},
            },
        ];
        Object.keys(vppKeySystems).forEach((systemKey) => {
            const keySystemProps = vppKeySystems[systemKey];
            if (systemKey === 'WIDEVINE') {
                const source = sources[0];
                source.keySystems['com.widevine.alpha'] = keySystemProps.url;
            }
            else if (systemKey === 'PLAYREADY') {
                const source = sources[0];
                source.keySystems['com.microsoft.playready'] = keySystemProps.url;
            }
            else if (systemKey === 'FAIRPLAY' && isSafari) {
                const config = {
                    src,
                    type: videoType,
                    withCredentials: false,
                    keySystems: {},
                };
                sources = [config];
                config.keySystems['com.apple.fps.1_0'] = {
                    certificateUri: keySystemProps.certificateURL,
                    licenseUri: keySystemProps.url,
                    getContentId: function (_emeOptions, contentId) {
                        const skd = new URL(contentId.substring(4));
                        return `keyId=${skd.searchParams.get('keyId')}&contentId=${skd.searchParams.get('contentId')}`;
                    },
                    getLicense: function (emeOptions, contentId, keyMessage, callback) {
                        console.log(emeOptions);
                        fetch(`${emeOptions.keySystems['com.apple.fps.1_0'].licenseUri}&${contentId}`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/octet-stream',
                            },
                            body: keyMessage,
                        })
                            .then((response) => {
                            if (response.ok) {
                                return response.arrayBuffer();
                            }
                            throw new Error(`Status: ${response.status || 'Unknown'}. Refresh request failed`);
                        })
                            .then((response) => {
                            console.log(response);
                            callback(null, response);
                        })
                            .catch((error) => {
                            console.error('❌ License request failed', error);
                            callback(error, null);
                        });
                    },
                };
            }
        });
        return sources;
    }
}
// Tells videojs about our custom drmSource plugin.
videojs.registerPlugin('drmSource', DRMSource);
